import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../../../interfaces/PaginatedResponse';
import { Refund } from '../../../../interfaces/Refund/Refund';
import { Pagination } from '../../../../interfaces/Pagination';
import { getRefunds } from '../../../../api/Refund';
import { bodyWidth } from '../../../../utils/Style';
import { AccountNavbar } from '../../AccountNavbar';
import { RefundsTable } from './RefundsTable';
import { GenericHelmet } from '../../../../components/Helmet/GenericHelmet';
import { useLocalizedText } from '../../../../hooks/useLocalizedText';

export const RefundsPage = () => {
  const t = useLocalizedText();

  const [loading, setLoading] = useState(false);
  const [refunds, setRefunds] = useState<PaginatedResponse<Refund>>({
    data: [],
    totalCount: 0,
  });
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    pageSize: 10,
  });

  const refreshRefunds = () => {
    setLoading(true);
    getRefunds(pagination)
      .then(setRefunds)
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshRefunds();
  }, [pagination]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title={t('account.refunds.title')} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          pb: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <AccountNavbar selectedTab='refunds' />

        <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>
          {t('account.refunds.title')}
        </Typography>

        <RefundsTable
          refunds={refunds.data}
          totalCount={refunds.totalCount}
          pagination={pagination}
          onPagination={setPagination}
          loading={loading}
        />
      </Box>
    </Box>
  );
};
